
  if (window.res_pixel_enabled){
    // log reference errors
    window.onerror = function(message, file, line, col, error) {
        // debugger
        let attributes = {
            request_error_type: message,
            file: file,
            line: line,
            request_error_severity: 'ERROR',
            request_error_message: ('An error occured at line ' + line + ' of ' + file + ': ' + message).replace(/"/g, '\\\"')

        }
        let event = new resEvent(null, 'Request Error', attributes)
        event.post()
    };
    // Log broken images as an error
    $(window).load(function() {
        $('img').each(function() {
            if ($(this).attr("src") && (!this.complete || typeof this.naturalWidth == "undefined" || this.naturalWidth == 0)) {
                let attributes = {
                    request_error_type: 'Image not found',
                    file: $(this).attr("src").replace(/"/g, '\\\"'),
                    request_error_severity: 'WARNING',
                    request_error_message: ('Image not found\\: ' + $(this).attr("src")).replace(/"/g, '\\\"')

                }
                let event = new resEvent(null, 'Request Error', attributes)
                event.post()
            }
        });
    });
  }

